// @ts-nocheck
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for KebZingel controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, KebZingelReservation } from "../models";

@Injectable({ providedIn: "root" })
export class KebZingelService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getReservations(start: Date, end: Date, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<KebZingelReservation>>;
    getReservations(start: Date, end: Date, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<KebZingelReservation>>>;
    getReservations(start: Date, end: Date, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<KebZingelReservation>>>;
    getReservations(start: Date, end: Date, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/KebZingel/Export/Reservations`;

        let params = new HttpParams();
        if (start != null) {
            params = HttpParamsBuilder.addToHttpParams(params, start, 'start');
        }
        if (end != null) {
            params = HttpParamsBuilder.addToHttpParams(params, end, 'end');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Add default headers if not already present
        if (!headers.has('X-Requested-With')) {
            headers = headers.set('X-Requested-With', 'XMLHttpRequest');
        }
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json, text/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
